<template>
<button class="vap-button" :class="[
        {'vap-button-outline' : outline},
        {'vap-button-rounded' : rounded},
        {'vap-button-action' : action},
        {'vap-button-disabled' : disabled},
        {'vap-button-dotdisabled' : dotDisabled},
        {'vap-button-working' : working},
        {'vap-button-iconp' : icon}
    ]" @click="handleClick" >

    <div v-if="icon" class="vap-button-icon">
        <svg height="50" version="1.1" width="50" xmlns="http://www.w3.org/2000/svg" style="transform: scale(1.4); margin-top: 20px; margin-left: 34px;">
            <path :d="path1"/>
        </svg>
    </div>

    {{ uppercase ? text.toUpperCase() : text }}

    <div v-if="working" class="vap-button-spinner">
        <Spinner small />
    </div>
</button>
</template>

<script>
import Spinner from '../nav/Spinner';

export default {
    name: 'vm-button',
    components: {
        Spinner
    },
    props: {
        text: {
            type: String,
            default: 'Button'
        },
        outline: {
            type: Boolean,
            default: false
        },
        rounded: {
            type: Boolean,
            default: false
        },
        uppercase: {
            type: Boolean,
            default: false
        },
        action: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        dotDisabled: {
            type: Boolean,
            default: false
        },
        working: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: undefined
        }
    },
    data() {
        return {
            path1: ''
        }
    },
    methods: {
        handleClick() {
            if (this.disabled || this.dotDisabled) return;
            this.$emit('clicked', true);
        }
    },
    async mounted() {
        switch (this.icon) {
            case 'download': 
                this.path1 = 'M 11 2 C 10.448 2 10 2.448 10 3 L 10 11 L 6 11 L 12 17 L 18 11 L 14 11 L 14 3 C 14 2.448 13.552 2 13 2 L 11 2 z M 2 20 L 2 22 L 22 22 L 22 20 L 2 20 z';
                this.path2 = '';
                break;
            case 'preview': 
                this.path1 = 'M 6 2 C 4.897 2 4 2.897 4 4 L 4 20 C 4 21.103 4.897 22 6 22 L 12.259766 22 C 12.039766 21.685 11.848641 21.35 11.681641 21 L 11.683594 21 C 11.679594 20.992 11.675875 20.983609 11.671875 20.974609 C 11.543875 20.702609 11.43675 20.420859 11.34375 20.130859 C 11.12675 19.458859 11 18.745 11 18 C 11 14.134 14.134 11 18 11 C 18.34 11 18.673 11.033078 19 11.080078 L 19 11.074219 C 19.342 11.124219 19.676 11.198922 20 11.294922 L 20 8 L 14 2 L 6 2 z M 13 3.4550781 L 18.5 9 L 13 9 L 13 3.4550781 z M 18 13 C 15.2 13 13 15.2 13 18 C 13 20.8 15.2 23 18 23 C 19 23 20.000781 22.699219 20.800781 22.199219 L 22.599609 24 L 24 22.599609 L 22.199219 20.800781 C 22.699219 20.000781 23 19 23 18 C 23 15.2 20.8 13 18 13 z M 18 15 C 19.7 15 21 16.3 21 18 C 21 19.7 19.7 21 18 21 C 16.3 21 15 19.7 15 18 C 15 16.3 16.3 15 18 15 z';
                this.path2 = '';
                break;
            case 'edit': 
                this.path1 = 'M 18.414062 2 C 18.158188 2 17.902031 2.0974687 17.707031 2.2929688 L 16 4 L 20 8 L 21.707031 6.2929688 C 22.098031 5.9019687 22.098031 5.2689063 21.707031 4.8789062 L 19.121094 2.2929688 C 18.925594 2.0974687 18.669937 2 18.414062 2 z M 14.5 5.5 L 3 17 L 3 21 L 7 21 L 18.5 9.5 L 14.5 5.5 z';
                this.path2 = '';
                break;
        }
    }
}
</script>

<style>

.vap-button {
    border: none;
    outline: none;
    background: none;

    min-height: 42px;

    font-size: 17px;
    font-weight: normal;
    color: white;

    padding: 0px 30px;

    border-radius: 5px;
    border: solid 2px #141f33;
    background-color: #141f33;
    cursor: pointer;
}
.vap-button:hover {
    opacity: 0.8;
}

.vap-button-rounded {
    border-radius: 21px;
}

.vap-button-working {
    padding-right: 40px;
    color: var(--button);
    background-color: white;
}

.vap-button-iconp {
    padding-bottom: 10px;
}

.vap-button-outline {
    color: var(--button);
    background-color: white;
}

.vap-button-action {
    min-width: 120px;
}

.vap-button-row-right .vap-button {
    margin-left: 10px;
}
.vap-button-row-center .vap-button {
    margin-left: 5px;
    margin-right: 5px;
}

.vap-button-disabled {
    background-color: #424f68;
    cursor: default;
    border-color: #424f68;
    opacity: 0.4;
}
.vap-button-disabled:hover {
    opacity: 0.4;
}

.vap-button-dotdisabled {
    color: gray;
    border: dotted 2px var(--text-disabled);
    background: none;
    cursor: default;
}
.vap-button-dotdisabled:hover {
    opacity: 1;
}

.vap-button-spinner {
    position: relative;
}


.ac-group .vap-button {
    width: 100%;
}


.vap-button-icon {
    margin-bottom: -20px;
}
path {
    fill: white;
}

</style>
